import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./App.css";
import "./css/common/HomeNavbar.css";
import "./css/home/HomePage.css";
import "./css/common/LoginUser.css";
import "./css/layouts/LoginScreen.css";
import "./css/others/loaderScreen.css";
import "./css/others/NotFound.css";
import "./css/layouts/AdminMainDashboard.css";
import "./css/layouts/SideBar.css";
import "./css/layouts/ManageAppPolicyPage.css";
import "./css/layouts/bookingPage.css";
import "./css/layouts/BookingTopMenu.css";

import { Toaster } from "react-hot-toast";

import HomeNavbar from "./components/common/HomeNavbar";
import PublicRoute from "./components/routesControll/PublicRoute";
import ProtectedRoute from "./components/routesControll/ProtectedRoute";

// Lazy Loading
const HomePage = lazy(() => import("./pages/home/HomePage"));
const LoginScreen = lazy(() => import("./components/layouts/LoginScreen"));
const Forgotpassword = lazy(() => import("./components/layouts/Forgotpassword"));
const NotFound = lazy(() => import("./components/others/NotFound"));

const AdminMainDashboard = lazy(() =>
  import("./components/dashboard/AdminMainDashboard")
);

const DashboardPage = lazy(() =>
  import("./components/layouts/DashboardPage")
);

const SettingPage = lazy(() =>
  import("./components/layouts/SettingPage")
);

const ManageAppPolicyPage = lazy(() =>
  import("./components/layouts/ManageAppPolicyPage")
);

const BookingPageLayout = lazy(() =>
  import("./components/layouts/BookingPageLayout")
);

const AcBookingPage = lazy(() =>
  import("./components/layouts/AcBookingPage")
);

const BikeBookingPage = lazy(() =>
  import("./components/layouts/BikeBookingPage")
);

const PetsGroomingPage = lazy(() =>
  import("./components/layouts/PetsGroomingPage")
);

const MensSalonPage = lazy(() =>
  import("./components/layouts/MensSalonPage")
);

const FemaleSalonPage = lazy(() =>
  import("./components/layouts/FemaleSalonPage")
);

const PaintingServicePage = lazy(() =>
  import("./components/layouts/PaintingServicePage")
);

const PartnerLeadMainPage = lazy(() =>
  import("./components/partner/PartnerLeadMainPage")
);

const PartnerLeadServicePage = lazy(() =>
  import("./components/partner/leads/PartnerLeadServicePage")
);

const LeadDetailsPage = lazy(() =>
  import("./components/partner/leads/LeadDetailsPage")
);

const AdminManagerPage = lazy(() =>
  import("./components/layouts/AdminManagerPage")
);

// Loader
function PageLoader() {
  return (
    <div className="loaderScreen">
      <div className="loader"></div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 2000,
          style: {
            background: "#222",
            color: "#fff",
            fontSize: "12px",
          },
        }}
      />

      <HomeNavbar />

      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route
            path="/forgot/password"
            element={<Forgotpassword text="Change Password" />}
          />

          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginScreen text="Login" />
              </PublicRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AdminMainDashboard />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />

            <Route path="setting" element={<SettingPage />} />

            <Route path="admin-manager" element={<AdminManagerPage />} />

            <Route path="verifyed-booking" element={<BookingPageLayout />}>
              <Route index element={<AcBookingPage />} />
              <Route path="bike" element={<BikeBookingPage />} />
              <Route path="pets" element={<PetsGroomingPage />} />
              <Route path="mens-salon" element={<MensSalonPage />} />
              <Route path="female-salon" element={<FemaleSalonPage />} />
              <Route
                path="painting-services"
                element={<PaintingServicePage />}
              />
            </Route>

            <Route
              path="manage-app-policy-details"
              element={<ManageAppPolicyPage />}
            />

            <Route path="partner-leads" element={<PartnerLeadMainPage />} />
            <Route
              path="partner-leads/:serviceSlug"
              element={<PartnerLeadServicePage />}
            />
            <Route
              path="partner-leads/:serviceSlug/:leadId"
              element={<LeadDetailsPage />}
            />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;